import React from 'react'

// component
import ButtonControl from '../../Control/Button'
import AlertPopup from '../AlertPopup'
// import AlertPopup from '../../../AlertPopup'
// import ButtonControl from '../../../../controls/ButtonControl'

const btnExtendStyles = `
    padding: 6px 34px;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 128.91%;
    border-radius: 6px;
    margin-right: 37px;
`
const alertPopupExtendStyles = `
    width: 540px;
    max-width: 540px;
    background-color: #FFEBEA;
    border: 1px solid #FF3B30;
    margin: 20px auto 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
`

const ErrorConnect = ({ handleClose, children }) => {
    const btn = (
        <ButtonControl 
            type="ERROR" 
            extendStyles={btnExtendStyles}
        >
            OK
        </ButtonControl>
    )

    return (
        <AlertPopup 
            type="ERROR" 
            btn={btn} 
            extendStyles={alertPopupExtendStyles}
            handleClose={handleClose}
        >
            {children}
        </AlertPopup>
    )
}

const MemoErrorConnect = React.memo(ErrorConnect)
MemoErrorConnect.displayName = 'MemoErrorConnect'

export default MemoErrorConnect
